(() => {
  'use strict';
  if (window.CasemetaProductTransition) return;
  const $ = (s, root = document) => root.querySelector(s);
  const infoSelector = 'product-info[id^="MainProduct"]';
  const pages = new Map();
  const loadedAssets = new Set([...document.querySelectorAll('script[src]')].map(s=>s.src));
  const disabledButtons = new WeakMap();
  let request = 0, abort;
  function destination(path) {
    const url = new URL(path, location.origin);
    const theme = window.Shopify?.theme;
    if (theme && theme.role !== 'main') url.searchParams.set('preview_theme_id', theme.id);
    return url;
  }
  async function load(url, signal) {
    if (pages.has(url.href)) return new DOMParser().parseFromString(pages.get(url.href), 'text/html');
    const main = $(infoSelector)?.dataset.section;
    const details = $('.cm-product-content')?.closest('.shopify-section')?.id.replace(/^shopify-section-/, '');
    let html, doc;
    if (main && details) {
      const sectionURL = new URL(url); const ids = [main, details, 'cm-product-metadata'];
      sectionURL.searchParams.set('sections', ids.join(','));
      try {
        const response = await fetch(sectionURL, { signal });
        if (!response.ok) throw new Error('Ürün bölümleri yüklenemedi.');
        const sections = await response.json();
        if (ids.some(id => typeof sections[id] !== 'string')) throw new Error('Ürün bölümü bulunamadı.');
        html = ids.map(id => sections[id]).join('\n');
        doc = new DOMParser().parseFromString(html, 'text/html');
        if (!$(infoSelector,doc) || !$('.cm-product-content',doc) || !$('[data-cm-product-metadata]',doc)) doc = null;
      } catch (error) { if (error.name === 'AbortError' || signal.aborted) throw error; }
    }
    // A different product template or unavailable section keeps the original
    // full-page fallback. Never cache or swap an incomplete section response.
    if (!doc) {
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Ürün yüklenemedi.');
      html = await response.text();
      doc = new DOMParser().parseFromString(html, 'text/html');
    }
    if (!$(infoSelector, doc) || !$('.cm-product-content', doc)) throw new Error('Ürün alanı bulunamadı.');
    if (pages.size >= 6) pages.delete(pages.keys().next().value);
    pages.set(url.href, html);
    return doc;
  }
  async function loadNewAssets(nextInfo) {
    for (const script of nextInfo.querySelectorAll('script[src]')) {
      const url = new URL(script.getAttribute('src'), location.origin);
      // Only load theme assets; app bootstraps retain their normal page lifecycle.
      if (loadedAssets.has(url.href) || url.origin !== location.origin || !url.pathname.includes('/assets/')) continue;
      await new Promise((resolve, reject)=>{
        const asset = document.createElement('script'); asset.src = url.href;
        asset.onload = resolve; asset.onerror = reject; document.head.append(asset);
      });
      loadedAssets.add(url.href);
    }
  }
  function updateMetadata(doc) {
    const metadata = $('[data-cm-product-metadata]',doc);
    if (metadata) {
      const title = document.createElement('textarea'); title.innerHTML = metadata.dataset.title;
      document.title = title.value;
    } else document.title = doc.title;
    ['link[rel="canonical"]','meta[name="description"]','meta[property="og:title"]','meta[property="og:url"]','meta[property="og:image"]'].forEach(selector=>{
      const old = $(selector), next = $(selector,doc);
      if (old && next) old.replaceWith(document.importNode(next,true));
    });
  }
  function removeProductModal(info) {
    // Dawn moves the zoom modal under <body>. Replacing product-info alone
    // leaves that old modal behind, so the next opener finds its stale ID first.
    const id = `ProductModal-${info.dataset.section}`;
    document.querySelectorAll('product-modal').forEach(modal => {
      if (modal.id !== id) return;
      if (modal.hasAttribute('open')) modal.hide();
      modal.remove();
    });
  }
  async function navigate(path, opener, fromHistory = false) {
    const url = destination(path), oldInfo = $(infoSelector);
    if (!oldInfo || url.origin !== location.origin || !/\/products\//.test(url.pathname)) return false;
    // Customix forms keep their page initialization and entered personalization.
    if ($('[data-cm-product-case-picker]')?.dataset.personalized === 'true') { location.assign(url.href); return true; }
    const ticket = ++request; abort?.abort(); abort = new AbortController();
    // A pending color response must not restore the old product URL after a case switch.
    oldInfo.abortController?.abort();
    const y = scrollY, selected = document.activeElement;
    oldInfo.setAttribute('aria-busy','true'); opener?.setAttribute('aria-busy','true');
    const submitButtons = [...oldInfo.querySelectorAll('product-form button[type="submit"], variant-selects select, variant-selects input, variant-selects button')];
    submitButtons.forEach(button=>{
      if (!disabledButtons.has(button)) disabledButtons.set(button,button.disabled);
      button.disabled = true;
    });
    try {
      const doc = await load(url, abort.signal);
      if (ticket !== request) return true;
      if ($('[data-cm-product-case-picker]',doc)?.dataset.personalized === 'true') { location.assign(url.href); return true; }
      const nextInfo = $(infoSelector,doc);
      const oldDetails = $('.cm-product-content')?.closest('.shopify-section');
      const nextDetails = $('.cm-product-content',doc)?.closest('.shopify-section');
      if (!oldDetails || !nextDetails) throw new Error('Ortak içerik bulunamadı.');
      await loadNewAssets(nextInfo);
      if (ticket !== request) return true;
      if (!fromHistory) history.replaceState({...history.state,cmProduct:true,y},'',location.href);
      window.CasemetaStorefront?.cleanupProduct(oldDetails);
      window.CasemetaStorefront?.cleanupProduct(oldInfo);
      removeProductModal(oldInfo);
      // Imported custom elements reconnect normally; already-loaded scripts are not rerun.
      nextInfo.querySelectorAll('script[src]').forEach(s=>s.remove());
      oldInfo.replaceWith(document.importNode(nextInfo,true));
      oldDetails.replaceWith(document.importNode(nextDetails,true));
      updateMetadata(doc);
      if (!fromHistory) history.pushState({cmProduct:true,y},'',url.href);
      document.dispatchEvent(new CustomEvent('cm:product:changed'));
      window.CasemetaStorefront?.refreshProduct();
      window.Shopify?.PaymentButton?.init?.();
      if (selected && !selected.isConnected) $('.cm-product-nav [data-axis="case"] [aria-current="page"]')?.focus({preventScroll:true});
      window.scrollTo({top:fromHistory ? (history.state?.y ?? y) : y,behavior:'instant'});
      return true;
    } catch (error) {
      if (error.name !== 'AbortError' && ticket === request) location.assign(url.href);
      return true;
    } finally {
      opener?.removeAttribute('aria-busy');
      if (ticket === request) {
        $(infoSelector)?.removeAttribute('aria-busy');
        submitButtons.forEach(button=>{
          if (button.isConnected) button.disabled = disabledButtons.get(button);
          disabledButtons.delete(button);
        });
      }
    }
  }
  document.addEventListener('click',event=>{
    const link = event.target.closest('.cm-product-nav [data-axis="case"] a.cm-product-nav__card');
    if (!link || link.hasAttribute('data-cm-full-page') || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    event.preventDefault();
    // A click back to the visible case must supersede an in-flight switch.
    // Otherwise the older response can select a case the customer just rejected.
    if (link.getAttribute('aria-current') === 'page' && !$(infoSelector)?.hasAttribute('aria-busy')) return;
    navigate(link.href,link);
  });
  addEventListener('popstate',()=>{
    if (!$(infoSelector)) return;
    const current = destination($(infoSelector).dataset.url), target = new URL(location.href);
    const variant = $('product-info product-form input[name="id"]')?.value;
    if (current.pathname !== target.pathname || (target.searchParams.has('variant') && target.searchParams.get('variant') !== variant)) navigate(target.href,null,true);
  });
  window.CasemetaProductTransition = {navigate};
})();
